// ---- Wallet (client mirror of the server-owned obol balance) ----
// Obol is CURRENCY, not a bag item: the server owns the balance on the character
// (charCtx.obol) and streams a `wallet` message (net.ts) whenever it changes — a
// buy/sell, or dropping / picking up a coin pile — with the initial balance riding
// the join `spawn`. This module owns the bottom-right obol pill + a small
// drop-quantity popover. Dropping sends a `dropObol` INTENT; the server validates the
// amount, debits, and spawns the pile at the player's feet (it owns the drop point),
// then echoes the new balance. So the client can never mint or over-drop obol.

import { $ } from "./dom.ts";

let obol = 0;
let walletEl: HTMLElement;
let countEl: HTMLElement;
let dropWrap: HTMLElement;
let qtyEl: HTMLInputElement;
let onDropObol: (amount: number) => void = () => {};

export function initWallet(dropHandler: (amount: number) => void): void {
  onDropObol = dropHandler;
  walletEl = $<HTMLElement>("#wallet");
  countEl = $<HTMLElement>("#obolCount");
  dropWrap = $<HTMLElement>("#obolDrop");
  qtyEl = $<HTMLInputElement>("#obolQty");
  walletEl.addEventListener("click", toggleDrop);
  $<HTMLButtonElement>("#obolDropBtn").addEventListener("click", confirmDrop);
  render();
}

/** Current obol balance — a UX hint for the shop panel (server re-validates). */
export function walletObol(): number {
  return obol;
}

/** Mirror an authoritative balance from the server (`wallet` message / join spawn). */
export function setWallet(n: number): void {
  obol = Math.max(0, Math.floor(n));
  qtyEl.max = String(Math.max(1, obol));
  render();
}

/** Toggle the drop-quantity popover (only when there's something to drop). */
function toggleDrop(): void {
  const show = !dropWrap.classList.contains("show") && obol > 0;
  dropWrap.classList.toggle("show", show);
  walletEl.classList.toggle("active", show);
}

function confirmDrop(): void {
  const amt = Math.floor(Number(qtyEl.value) || 0);
  if (amt <= 0 || amt > obol) return; // server re-checks; this is just UX
  onDropObol(amt); // server debits + spawns the coin pile, then echoes the new balance
  dropWrap.classList.remove("show");
  walletEl.classList.remove("active");
}

function render(): void {
  countEl.textContent = String(obol);
}
